import { render, staticRenderFns } from "./buyPopup.vue?vue&type=template&id=b1738f6a&"
import script from "./buyPopup.vue?vue&type=script&lang=js&"
export * from "./buyPopup.vue?vue&type=script&lang=js&"
import style0 from "./buyPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports